module.exports = __webpack_public_path__ + "static/media/room-placeholder.2740bdf9.jpg";